module.exports = __webpack_public_path__ + "static/media/galerija_2021 (19).67a3be88.jpg";